"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var override_service_1 = require("@services/overrides/override-service");
var environment_1 = require("@shared/types/environment");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (angularModule) {
    angularModule.factory('prDynamicTranslationsHelperUtils', [
        '$http',
        '$q',
        '$injector',
        'rsEnvironment',
        'pr.API_ROUTES',
        'prOverrideTrigger',
        'pr.customFilterUtils',
        function (
        // @ts-ignore
        $http, 
        // @ts-ignore
        $q, 
        // @ts-ignore
        $injector, 
        // @ts-ignore
        env, 
        // @ts-ignore
        API_ROUTES, triggerOverrides, 
        // @ts-ignore
        customFilterUtils) {
            var nonOverrideableLabels = ['translatableAttributes', 'translationId', 'grouped'];
            var getBaseUrl = function () {
                return API_ROUTES.DYNAMIC_TRANSLATIONS;
            };
            /**
             * Returns true if viewConfig or orderedMetrics contain
             * `translatableAttributes` or `translationId` field
             */
            // @ts-ignore
            // @ts-ignore
            var hasTranslationAttributes = function (viewConfig, orderedMetrics) {
                return !!(viewConfig.translationId || viewConfig.translatableAttributes ||
                    hasTranslationAttributesHelper(viewConfig, 'labelOverrides') ||
                    hasTranslationAttributesHelper(viewConfig, 'statsLabelOverrides') ||
                    hasTranslationAttributesHelper(viewConfig, 'axisLabelOverrides') ||
                    hasTranslationAttributesHelper(viewConfig, 'options') ||
                    (lodash_1.default.some(orderedMetrics, 'translationId') || lodash_1.default.some(orderedMetrics, 'translatableAttributes')));
            };
            /**
             * Check if the viewConfig has a given property.
             * If so, check if that property has translation attributes
             */
            // @ts-ignore
            // @ts-ignore
            function hasTranslationAttributesHelper(viewConfig, property) {
                return viewConfig[property] && hasTranslationProperties(viewConfig[property]);
            }
            // Check if a given object has translation attributes
            // @ts-ignore
            function hasTranslationProperties(obj) {
                return (obj.translationId || obj.translatableAttributes);
            }
            /**
             * Before the implementation of dynamic translations,
             * if a user edited a label in either bar or line widgets,
             * the override would get keyed by the translated metric. This function
             * migrates them back to use the untranslated, static key
             */
            // @ts-ignore
            // @ts-ignore
            var migrateSingleMetricLabelOverrides = function (metric, labelOverrides) {
                var translatedKey = (metric.description
                    || metric.name
                    || metric.label
                    || metric.fieldId);
                if (labelOverrides[translatedKey]) {
                    labelOverrides[metric.type] = labelOverrides[translatedKey];
                    delete labelOverrides[translatedKey];
                }
            };
            /**
             * Adds translation attributes to the viewConfig and orderedMetrics
             */
            // @ts-ignore
            // @ts-ignore
            var addDynamicTranslationsWidgetAttributes = function (viewConfig, orderedMetrics) {
                viewConfig = viewConfig || {};
                orderedMetrics = orderedMetrics || [];
                addDynamicTranslationsWidgetAttributesToViewConfig(viewConfig);
                addDynamicTranslationsWidgetAttributesToOrderedMetrics(orderedMetrics);
            };
            var addDynamicTranslationsAttributesForFilters = function (filters) {
                var savedFilters = {};
                lodash_1.default.forEach(filters, function (filter, surveyId) {
                    if (filter && !customFilterUtils.isCustomFilterId(filter.filterId)) {
                        var key = surveyId + "-" + filter.filterId;
                        // @ts-ignore
                        savedFilters[key] = {
                            filterName: '',
                            translationId: filter.filterId,
                            translatableAttributes: ['filterName']
                        };
                    }
                });
                return savedFilters;
            };
            var addDynamicTranslationsAttributesForCustomFilters = function (customFilterMap) {
                var customFilters = {};
                lodash_1.default.forEach(customFilterMap, function (filters, fieldsetId) {
                    // @ts-ignore
                    customFilters[fieldsetId] = {};
                    lodash_1.default.forEach(filters, function (filter) {
                        // @ts-ignore
                        customFilters[fieldsetId][filter.filterId] = __assign(__assign({}, filter), { translationId: filter === null || filter === void 0 ? void 0 : filter.filterId, translatableAttributes: ['filterName'] });
                    });
                });
                return customFilters;
            };
            /**
             * GET request that fetches the static translations for the app
             * with given language code.
             */
            var getStaticTranslations = function (languageCode) {
                if (!languageCode) {
                    console.error('No languageCode is passed for getting static translations.');
                    return $q.when();
                }
                var path = API_ROUTES.DYNAMIC_TRANSLATIONS + "/staticTranslations";
                return $http.get(path, {
                    headers: {
                        'Content-Language': languageCode
                    }
                    // @ts-ignore
                }).then(function (res) {
                    if (lodash_1.default.get(res, ['data', languageCode])) {
                        return res.data[languageCode];
                    }
                    throw new Error('No static translations in response');
                    // @ts-ignore
                }).catch(function (error) {
                    console.error("Error getting static translations for language: " + languageCode, error);
                    throw error;
                });
            };
            /**
             * Determines if dynamic translations is supported by checking the override config and the FF.
             * Dynamic translations is not supported in RC.
             */
            var isDynamicTranslationsSupported = function () {
                var configFlags = triggerOverrides({
                    event: override_service_1.OVERRIDE_EVENTS.CONFIG_FLAGS,
                    data: {},
                    sync: true
                });
                return lodash_1.default.get(configFlags, 'enableDynamicTranslations', false)
                    && env.get(environment_1.ENV_VARS.DYNAMIC_TRANSLATIONS);
            };
            // @ts-ignore
            function addDynamicTranslationsWidgetAttributesToViewConfig(viewConfig) {
                addBaseTranslations(viewConfig);
                addLegendTranslations(viewConfig);
                addAxisTranslations(viewConfig);
                addStatsTranslations(viewConfig);
                addImageTranslations(viewConfig);
            }
            // @ts-ignore
            function addDynamicTranslationsWidgetAttributesToOrderedMetrics(orderedMetrics) {
                lodash_1.default.forEach(orderedMetrics, function (orderedMetric) {
                    if (orderedMetric && orderedMetric.key) {
                        orderedMetric.translationId = orderedMetric.key;
                        orderedMetric.translatableAttributes = ['label'];
                    }
                });
            }
            // @ts-ignore
            function addBaseTranslations(viewConfig) {
                if (!viewConfig.translationId) {
                    viewConfig.translationId = 'field';
                }
                if (!viewConfig.translatableAttributes) {
                    viewConfig.translatableAttributes = ['fieldNameOverride', 'axisFieldNameOverride'];
                }
            }
            // @ts-ignore
            function addLegendTranslations(viewConfig) {
                if (viewConfig.labelOverrides) {
                    if (!viewConfig.labelOverrides.translationId) {
                        viewConfig.labelOverrides.translationId = 'legendMetric';
                    }
                    if (!viewConfig.labelOverrides.translatableAttributes) {
                        viewConfig.labelOverrides.translatableAttributes =
                            generateTranslatableAttributesFromLabelOverrides(viewConfig.labelOverrides);
                    }
                }
            }
            // @ts-ignore
            function addAxisTranslations(viewConfig) {
                if (viewConfig.axisLabelOverrides) {
                    if (!viewConfig.axisLabelOverrides.translationId) {
                        viewConfig.axisLabelOverrides.translationId = 'axisChoice';
                    }
                    if (!viewConfig.axisLabelOverrides.translatableAttributes) {
                        viewConfig.axisLabelOverrides.translatableAttributes =
                            generateTranslatableAttributesFromLabelOverrides(viewConfig.axisLabelOverrides);
                    }
                }
            }
            // @ts-ignore
            function addStatsTranslations(viewConfig) {
                if (viewConfig.statsLabelOverrides) {
                    if (!viewConfig.statsLabelOverrides.translationId) {
                        viewConfig.statsLabelOverrides.translationId = 'axisChoice';
                    }
                    if (!viewConfig.statsLabelOverrides.translatableAttributes) {
                        viewConfig.statsLabelOverrides.translatableAttributes =
                            generateTranslatableAttributesFromLabelOverrides(viewConfig.statsLabelOverrides);
                    }
                }
            }
            var addImageTranslations = function (viewConfig) {
                if (viewConfig.options) {
                    viewConfig.options = __assign(__assign({}, viewConfig.options), { translationId: 'image', translatableAttributes: ['imageAltText', 'imageURL'] });
                }
            };
            // @ts-ignore
            function generateTranslatableAttributesFromLabelOverrides(labelOverrides) {
                return lodash_1.default.chain(labelOverrides)
                    .keys()
                    .map(function (labelOverride) {
                    if (lodash_1.default.includes(nonOverrideableLabels, labelOverride)) {
                        return;
                    }
                    return labelOverride;
                })
                    .filter()
                    .value();
            }
            return {
                getBaseUrl: getBaseUrl,
                hasTranslationAttributes: hasTranslationAttributes,
                migrateSingleMetricLabelOverrides: migrateSingleMetricLabelOverrides,
                addDynamicTranslationsWidgetAttributes: addDynamicTranslationsWidgetAttributes,
                addDynamicTranslationsAttributesForFilters: addDynamicTranslationsAttributesForFilters,
                addDynamicTranslationsAttributesForCustomFilters: addDynamicTranslationsAttributesForCustomFilters,
                getStaticTranslations: getStaticTranslations,
                isDynamicTranslationsSupported: isDynamicTranslationsSupported
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
